export default {
  toasts: {
    auth_token_invalid: 'Token de autenticación no válido',
    host_access_refused:
      'Esta dirección pertenece a un partner del que tu cuenta no forma parte. Inicia sesión en tu propia dirección.',
  },
};
